import React, { useState } from 'react';
import CustomerForm from './CustomerForm';
import InstallerForm from './InstallerForm';
import CompanyForm from './CompanyForm';
import AccountTypeSelector from './AccountTypeSelector';
import VerifyUser from './VerifyUser';

const HGSignUp = () => {
    const [accountType, setAccountType] = useState('');
    const [newUser, setNewUser] = useState(null);

    return (
        <div className="flex min-h-[160px] w-full flex-col items-center justify-around sm:min-h-[200px]">
            {newUser ? (
                <VerifyUser newUser={newUser} />
            ) : (
                <>
                    {accountType === 'customer' ? (
                        <CustomerForm setNewUser={setNewUser} />
                    ) : accountType === 'installer' ? (
                        <InstallerForm setNewUser={setNewUser} />
                    ) : accountType === 'company' ? (
                        <CompanyForm setNewUser={setNewUser} />
                    ) : (
                        <AccountTypeSelector setAccountType={setAccountType} />
                    )}
                </>
            )}
        </div>
    );
};

export default HGSignUp;
